// extracted by extract-css-chunks-webpack-plugin
module.exports = {"create_page":"CreatePage__create_page--1Vc9Q","options":"CreatePage__options--1YOas"};